import useDrawerStack from 'Hooks/useDrawerStack';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { useQueryClient } from '@tanstack/react-query';
import AISuggestionsDrawerItem from './AISuggestionsDrawerItem';
import { DRAWER_STACK } from 'Utils/constants';
import { mergeContacts } from 'Services/automations';

export default function AISuggestionsDrawerContactDuplicatedDetected(props) {
    const { className, contacts_duplicated, onAccept, onReject } = props;

    const { open } = useDrawerStack();
    const { t } = useTranslation('contacts');
    const queryClient = useQueryClient();

    const handleSubmit = async ({ contactId, contactIdsToMerge }) => {
        if (!contactId) return;

        const response = await mergeContacts(contactId, contactIdsToMerge);
        await queryClient.invalidateQueries({ queryKey: ['contacts'] });
        const contact = {
            id: response.id,
        };
        onAccept(contact);
    };

    const handleClick = () => {
        open(DRAWER_STACK.CONTACT_MERGE, {
            title: t('contacts-duplicated'),
            onCancel: onReject,
            onSubmit: handleSubmit,
            contact_duplicated_ids: contacts_duplicated.map((contact) => contact.id),
            submitButtonText: t('merge-contacts'),
            cancelButtonText: t('reject-suggestion'),
        });
    };

    const displayName = contacts_duplicated.filter((c) => c.name)[0]?.name || '-';

    return (
        <AISuggestionsDrawerItem
            image={
                <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" fill="none" viewBox="0 0 48 48">
                    <circle cx="24" cy="24" r="21" fill="#FF7F5B"></circle>
                    <path
                        stroke="#fff"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="1.5"
                        d="M28.09 31.727v-1.636a3.273 3.273 0 0 0-3.272-3.273h-6.545A3.273 3.273 0 0 0 15 30.091v1.636M21.545 23.546a3.273 3.273 0 1 0 0-6.546 3.273 3.273 0 0 0 0 6.546M33 31.727v-1.636a3.27 3.27 0 0 0-2.455-3.167M27.273 17.106a3.273 3.273 0 0 1 0 6.341"
                    ></path>
                </svg>
            }
            className={className}
            onClick={handleClick}
            label={t('contacts-duplicated')}
            title={displayName}
            onClose={onReject}
        />
    );
}

AISuggestionsDrawerContactDuplicatedDetected.propTypes = {
    className: PropTypes.string,
    contacts_duplicated: PropTypes.arrayOf(
        PropTypes.shape({
            id: PropTypes.string.isRequired,
            name: PropTypes.string.isRequired,
        }),
    ).isRequired,
    onAccept: PropTypes.func.isRequired,
    onReject: PropTypes.func.isRequired,
};
